module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/dia#_idTextAnchor001"
    }
  }, [_vm._v("Diagram of the Human Brain")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/preface#_idTextAnchor002"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ack#_idTextAnchor007"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/pt1#_idTextAnchor008"
    }
  }, [_c('b', [_vm._v("SECTION 1")]), _c('br'), _vm._v("God, the Brain and What Went Wrong")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1#_idTextAnchor010"
    }
  }, [_c('b', [_vm._v("Chapter 1")]), _c('br'), _vm._v("\nGod Is Love")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch2#_idTextAnchor017"
    }
  }, [_c('b', [_vm._v("Chapter 2")]), _c('br'), _vm._v("The Human Brain and Broken Love")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#_idTextAnchor032",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 3")]), _c('br'), _vm._v("\nThe Infection of Fear")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#_idTextAnchor048",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 4")]), _c('br'), _vm._v("\nFreedom to Love")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/pt2#_idTextAnchor062",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("SECTION II")]), _vm._v(" "), _c('br'), _vm._v("The Battle Between The Conflicting Views About God")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#_idTextAnchor063",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 5")]), _c('br'), _vm._v("Love Strikes Back")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#_idTextAnchor064",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 6")]), _c('br'), _vm._v("Engaging the Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#_idTextAnchor065",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 7")]), _c('br'), _vm._v("Love Stands Firm")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#_idTextAnchor067",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 8")]), _c('br'), _vm._v("Changing Our View of God")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9#_idTextAnchor069",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 9")]), _c('br'), _vm._v("The Power of Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10#_idTextAnchor072",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 10")]), _c('br'), _vm._v("The Truth About Sin")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch11#_idTextAnchor073",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 11")]), _c('br'), _vm._v("Enlarging Our View of God")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch12#_idTextAnchor076",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 12")]), _c('br'), _vm._v("The Judgment of God")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch13#_idTextAnchor078",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 13")]), _c('br'), _vm._v("In the Brain of Christ")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/pt3#_idTextAnchor098",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("SECTION III")]), _c('br'), _vm._v("Embracing the Goodness of God")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch14#_idTextAnchor099",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 14")]), _c('br'), _vm._v("Forgiveness")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch15#_idTextAnchor104",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 15")]), _c('br'), _vm._v("When Good Prevails")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch16#_idTextAnchor108",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 16")]), _c('br'), _vm._v("When Love Burns Free")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch17#_idTextAnchor112",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Chapter 17")]), _c('br'), _vm._v("Buddha, Jesus and Preparing Your Brain for Eternity")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/add#_idTextAnchor127",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Addendum")]), _c('br'), _vm._v("Putting It All Together—Simple Steps to a Healthier Brain")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/studyguide#_idTextAnchor128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Study Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/gloss#_idTextAnchor146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#_idTextAnchor147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise#_idTextAnchor247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', {
    staticClass: "i"
  }, [_vm._v("The God-Shaped Brain")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ata#_idTextAnchor248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreivp#_idTextAnchor249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/rights#_idTextAnchor250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a166910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/toc.vue
// module id = 60
// module chunks = 0